import { Fragment } from 'react';

import OrgUnitAdminRosterEntriesSelectionLargeGrid from './OrgUnitAdminRosterEntriesSelectionLargeGrid';
import OrgUnitAdminRosterEntriesSelectionSmallGrid from './OrgUnitAdminRosterEntriesSelectionSmallGrid';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const OrgUnitAdminRosterEntriesSelectionGrid = ({ gridData, isLoading, onCheckboxChange, bonus, onAddOverrideEntryClicked, onEditOverrideEntryClicked }) => {
  return (
    <Fragment>
      {isLoading === false ?
        <div className="row">
          <div className="col-xs-12">
            {gridData.length > 499
              ? <p className={global.ErrorMessage}>More than 500 Search Results returned. Please add additional filters to narrow your search results.</p> :
              <p>{gridData.length === 1 ? `${gridData.length} Search Result` : `${gridData.length} Search Results`}</p>}
          </div>
        </div>
        : <Fragment><div className="row usas-extra-top-margin usas-extra-bottom-margin"></div></Fragment>}
      <OrgUnitAdminRosterEntriesSelectionLargeGrid
        gridData={gridData}
        isLoading={isLoading}
        onCheckboxChange={onCheckboxChange}
        bonus={bonus}
        onAddOverrideEntryClicked={onAddOverrideEntryClicked}
        onEditOverrideEntryClicked={onEditOverrideEntryClicked}
      />
      <OrgUnitAdminRosterEntriesSelectionSmallGrid
        gridData={gridData}
        isLoading={isLoading}
        onCheckboxChange={onCheckboxChange}
        bonus={bonus}
        onAddOverrideEntryClicked={onAddOverrideEntryClicked}
        onEditOverrideEntryClicked={onEditOverrideEntryClicked}
      />
    </Fragment>
  )
};

export default OrgUnitAdminRosterEntriesSelectionGrid;